export class RelatedEntitiesRevision {
  revisions: Array<{ code: string, display: string}>;
  revisedCurationItemId: string;

  constructor() {
    this.revisions = [];
  }
}

